import { createInputMapping } from "../model/ActionResolver";
import type { InputMapping } from "../types/action";

export interface InputHandlerContract {
  map(raw: string): InputMapping;
}

export interface InputHandlerOptions {
  readonly allowDebugShortcuts?: boolean;
}

function applyInputOptions(
  mapping: InputMapping,
  options: InputHandlerOptions,
): InputMapping {
  if (!options.allowDebugShortcuts && mapping.mapped === "toggleDebugFog") {
    return {
      raw: mapping.raw,
      mapped: null,
    };
  }

  return mapping;
}

export function mapKeyboardInput(
  raw: string,
  options: InputHandlerOptions = {},
): InputMapping {
  return applyInputOptions(createInputMapping(raw), options);
}

export class InputHandler implements InputHandlerContract {
  private readonly options: InputHandlerOptions;

  public constructor(options: InputHandlerOptions = {}) {
    this.options = options;
  }

  public map(raw: string): InputMapping {
    return mapKeyboardInput(raw, this.options);
  }
}
